import { createStore } from 'redux';
import oddReducer from '../reducer/odd';

const store = createStore(oddReducer);

store.dispatch({ type: 'FETCH_SYSTEM_ACTION' })

export default store;